import React, { useState } from 'react';
import colpensiones from '../../assets/colpensionesUniversal.png';
import ban100 from '../../assets/ban100.png';
import davivienda from '../../assets/daviviendaUniversal2.png';
import InfoCard from './InfoCard';

const Principal = ({ profileProgress, onOpenProfileFlow = () => {} }) => {
    const [activo, setActivo] = useState("6");
    const completed = profileProgress?.completed ?? 0;
    const total = profileProgress?.total ?? 0;
    const remaining = profileProgress?.remaining ?? Math.max(total - completed, 0);
    const needsReminder = Boolean(profileProgress?.needsCompletion) && total > 0;

    return (
        <div className="py-4">


            <div className="bg-[#e1edf3] rounded-xl p-4">

                <div className="flex items-center gap-2 pt-2 pb-8 rounded">
                    <span className="text-[#0047a0] text-xl font-bold">Buscar por fecha:</span>

                    {["6", "12", "18"].map((meses) => (
                        <button
                            key={meses}
                            onClick={() => setActivo(meses)}
                            className={`px-4 py-1 font-bold rounded ${activo === meses
                                    ? "bg-[#0060c4] text-white shadow-[inset_0_2px_6px_rgba(0,0,0,0.3)]"
                                    : "bg-white text-[#0060c4] shadow-[0_4px_8px_rgba(0,0,0,0.2)]"
                                }`}
                        >
                            {meses} meses
                        </button>
                    ))}


                    <div className="flex items-center ml-16 bg-white rounded  px-3 py-2 border border-[#cfd6e4]">
                        <input
                            className="outline-none text-[#6a7890] font-semibold placeholder-[#6a7890] w-96 bg-transparent"
                            placeholder="Buscar por nombre del fondo:"
                        />
                    </div>

                    <button className="bg-[#0060c4] text-white font-bold px-4 py-2 rounded shadow-[0_4px_8px_rgba(0,0,0,0.2)]">
                        Buscar
                    </button>
                </div>





                {needsReminder && (
                    <div className="mb-4 flex flex-col gap-3 rounded-xl border border-green-300 bg-green-100 px-4 py-3 text-green-900 shadow">
                        <div>
                            <p className="text-base font-bold">Completa tu información personal</p>
                            <p className="text-sm font-semibold">
                                Has guardado {completed} de {total} etapas. Te faltan {remaining}{' '}
                                etapa{remaining === 1 ? '' : 's'} por registrar.
                            </p>
                        </div>
                        <div>
                            <button
                                type="button"
                                onClick={onOpenProfileFlow}
                                className="rounded-lg bg-[#0346a4] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#02367f] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#02367f]/70"
                            >
                                Completar ahora
                            </button>
                        </div>
                    </div>
                )}

                <h2 className="text-3xl font-bold text-[#033d8e] mb-2">Pagos pendientes</h2>
                <div className="bg-[#dffed6] text-green-800 px-4 py-2 rounded font-semibold mb-2">¡Aún tienes tiempo para pagar!</div>
                <InfoCard
                    image={colpensiones}
                    startDate="22 noviembre 2022"
                    endDate="22 noviembre 2025"
                    buttonText="Pagar aquí"
                    onButtonClick={() => alert('Pago')}
                    showBoxColors={false}
                    boxes={[
                        { title: 'Valor a pagar', value: '$ 223,999', rate: '' },
                        { title: 'Vence', value: 'en 28 días', rate: 'Noviembre 22 de 2022' },
                        { title: 'Código', value: '2383293', rate: 'Octubre de 2021' },
                    ]}
                />

                <h2 className="text-3xl font-bold text-[#033d8e] mt-6">Fondos activos</h2>

                <h3 className="text-2xl font-bold text-[#004eba] mt-4 mb-1">MisCDTs</h3>
                <InfoCard
                    image={ban100}
                    startDate="22 noviembre 2022"
                    endDate="22 noviembre 2025"
                    buttonText="Ver más"
                    onButtonClick={() => alert('Ver más CDT')}
                    showBoxColors={true}
                    boxes={[
                        { title: 'Ingreso inicial', value: '💲5.255.949', rate: 'Tasa 10,5%' },
                        { title: 'Ingreso actual', value: '💲5.535.000', rate: 'Tasa 10,7%' },
                        { title: 'Ingreso esperado', value: '💲5.815.709', rate: 'Tasa 10,4%' },
                    ]}
                />

                <h3 className="text-2xl font-bold text-[#004eba] mt-4 mb-1">MisFICs</h3>
                <div className='pb-3'>
                    <InfoCard
                        image={ban100}
                        startDate="22 noviembre 2022"
                        endDate="22 noviembre 2025"
                        buttonText="Ver más"
                        onButtonClick={() => alert('Ver más FIC Ban100')}
                        showBoxColors={true}
                        boxes={[
                            { title: 'Ingreso inicial', value: '💲5.255.949', rate: 'Tasa 10,5%' },
                            { title: 'Ingreso actual', value: '💲5.535.000', rate: 'Tasa 10,7%' },
                            { title: 'Ingreso esperado', value: '💲5.815.709', rate: 'Tasa 10,4%' },
                        ]}
                    />

                </div>

                <InfoCard
                    image={davivienda}
                    startDate="22 noviembre 2022"
                    endDate="22 noviembre 2025"
                    buttonText="Ver más"
                    onButtonClick={() => alert('Ver más FIC Ban100')}
                    showBoxColors={true}
                    boxes={[
                        { title: 'Ingreso inicial', value: '💲5.255.949', rate: 'Tasa 10,5%' },
                        { title: 'Ingreso actual', value: '💲5.535.000', rate: 'Tasa 10,7%' },
                        { title: 'Ingreso esperado', value: '💲5.815.709', rate: 'Tasa 10,4%' },
                    ]}
                />

                <h3 className="text-2xl font-bold text-[#004eba] mt-4 mb-1">MiPension</h3>
                <InfoCard
                    image={colpensiones}
                    startDate="22 noviembre 2022"
                    endDate="22 noviembre 2025"
                    buttonText="Ver más"
                    onButtonClick={() => alert('Ver más MiPension')}
                    showBoxColors={true}
                    boxes={[
                        { title: 'Ingreso inicial', value: '💲5.255.949', rate: 'Tasa 10,5%' },
                        { title: 'Ingreso actual', value: '💲5.535.000', rate: 'Tasa 10,7%' },
                        { title: 'Ingreso esperado', value: '💲5.815.709', rate: 'Tasa 10,4%' },
                    ]}
                />
                <h2 className="text-3xl font-bold text-[#033d8e] mt-6">Fondos iniciados</h2>
                <h3 className="text-2xl font-bold text-[#004eba] mt-4 mb-1">MisCDTs</h3>
                <div className="bg-red-100 text-red-700 px-4 py-2 rounded font-medium mb-2">Iniciaste un CDT, completa los datos para finalizar el proceso.</div>
                <InfoCard
                    image={ban100}
                    startDate="22 noviembre 2022"
                    endDate="22 noviembre 2025"
                    buttonText="Ver más"
                    onButtonClick={() => alert('Ver más CDT')}
                    showBoxColors={true}
                    boxes={[
                        { title: 'Ingreso inicial', value: '💲5.255.949', rate: 'Tasa 10,5%' },
                        { title: 'Ingreso actual', value: '💲5.535.000', rate: 'Tasa 10,7%' },
                        { title: 'Ingreso esperado', value: '💲5.815.709', rate: 'Tasa 10,4%' },
                    ]}
                />

                
            </div>
        </div>
    );
};

export default Principal;
